import { Api } from "./Api.class";
const endpoint = "companies";
const companiesAPI = new Api(endpoint);
export default companiesAPI;
